<template>
    <main class="mt-5">
        <div class="card mt-3">
            <div class="card-header  border-0">
                <h5 class="card-title font-bold py-3">گزارش انبار گردانی شده ها</h5>
                <div style="flex: 1"></div>
                <button @click="print" class="btn btn-primary">
                    <span
                        style="transform: translateY(3px)"
                        class="feather-printer"
                    ></span>
                </button>
            </div>
            <div class="row px-4 not-in-print">
                <form
                    autocomplete="chrome-off"
                    @submit.prevent="doFilter"
                    class="col-12 row"
                >
                    <div class="row col-12">
                        <b-form-group class="col-md-4">
                            <multiselect
                                placeholder="انتخاب انبار"
                                v-model="selectedStore"
                                open-direction="bottom"
                                :options="stores"
                                label="label"
                                track-by="value"
                                :searchable="true"
                                :close-on-select="true"
                                :show-labels="false"
                                :disabled="disabled"
                            >
                                <template slot="noOptions"> موردی یافت نشد </template>
                                <template slot="noResult"> موردی یافت نشد </template>
                            </multiselect>
                        </b-form-group>
                        <div class="col-6">
                            <DatePickerRange
                                :fromFormatType="'YYYY-MM-DD'"
                                :toFormatType="'YYYY-MM-DD'"
                                :fromType="'date'"
                                :toType="'date'"
                                :dfFType="'jYYYY-jMM-jDD'"
                                :dfTType="'jYYYY-jMM-jDD'"
                                v-model="filter.date"
                            />
                        </div>
                    </div>
                    <div class="col-4">
                        <button :disabled="disabled" type="submit" class="btn btn-primary">
                            فیلتر
                        </button>
                    </div>
                </form>
            </div>
            <div id="print" class="p-4">
                <div class="print-only">
                    <h4>فروشگاه اروین</h4>
                </div>
                <br>
                <div
                    class="d-flex mb-3 mr-2-print"
                >
                    <span class="ml-1 font-bold">گزارش انبار گردانی شده ها</span>
                    <div v-if="appliedFilter.date.startDate">
                        <span>از</span>
                        <span class="font-weight-bold mx-1">تاریخ</span
                            ><span>{{ appliedFilter.date.startDate | persianDate }}</span>
                        </div>
                    <div class="mr-4" v-if="appliedFilter.date.endDate">
                        <span>تا</span>
                        <span class="font-weight-bold mx-1">تاریخ</span
                        ><span>{{ appliedFilter.date.endDate | persianDate }}</span>
                    </div>
                </div>
                <b-table
                    v-if="reports"
                    bordered
                    striped
                    :fields="fields"
                    :items="reports"
                    :sort-desc.sync="sortDesc"
                    responsive
                >
                    <template v-slot:cell(description)="data">  
                        <span v-if="data.item.description !== 'null'">  
                            {{ data.item.description }}  
                        </span>  
                        <span v-else>-</span>  
                    </template>
                </b-table>
                <div v-if="reports && !reports.length" class="alert alert-primary">  
                    اطلاعاتی موجود نیست
                </div>
            </div>
            <div class="d-flex flex-column w-100"></div>
        </div>
    </main>
</template>
<script>
    import { BTable, BFormGroup, BFormInput, BTd } from "bootstrap-vue";
    import mixins from '@@/core/mixins/mixins'
    import DatePickerRange from "@@/core/components/shared/DatePickerRange/DatePickerRange";
    import ExcelDownload from "@@/core/components/excelDownload/ExcelDownload";

    function Filter() {
        this.date = {
            startDate: "",
            endDate: "",
        };
    }

    Filter.prototype.set = function(filters) {
        Object.entries(filters).forEach(([index, value]) => {
            this[index] = value;
        });
    };

    export default {
        name: "StoreTaking",
        mixins: [mixins],
        components: {
            ExcelDownload,
            BTd,
            DatePickerRange,
            BTable,
            BFormGroup,
            BFormInput,
        },
        data() {
            return {
                disabled: false,
                fields: [
                    {
                    key: "id",
                    label: "شناسه",
                    },
                    {
                    key: "description",
                    label: "توضیحات",
                    },
                ],
                page: 1,
                perPage: 200,
                totals: null,
                reports: null,
                selectedStore: null,
                has_discount: null,
                sortBy: null,
                stores: [],
                sortDesc: null,
                filter: new Filter(),
                appliedFilter: new Filter(),
                currentPage: 1,
            };
        },
        created() {
            this.loadData();
            this.loadStores();
        },
        methods: {
            async loadStores(){
                try {
                    const response = await this.$axios.get("admin/stores");
                    this.stores = response.data.data.stores;
                    this.disabled = false;
                } catch (e) {
                    this.$root.notify(e);
                } 
            },
            print() {
                window.print();  
            },
            doFilter() {
                this.loadData();
            },
            async loadData() {
                try {
                    this.appliedFilter.set(this.filter);
                    const today = new Date();  
                    const startOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);  

                    function formatDate(date) {  
                        const year = date.getFullYear();  
                        const month = String(date.getMonth() + 1).padStart(2, '0');  
                        const day = String(date.getDate()).padStart(2, '0');  
                        const hours = String(date.getHours()).padStart(2, '0');  
                        const minutes = String(date.getMinutes()).padStart(2, '0');  
                        const seconds = String(date.getSeconds()).padStart(2, '0');  

                        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;  
                    }  
                    if (!this.appliedFilter.date.startDate || !this.appliedFilter.date.endDate) {  
                        this.appliedFilter.date.startDate = formatDate(startOfToday);  
                        this.appliedFilter.date.endDate = formatDate(today);  
                    }  
                    this.disabled = true;
                    const response = await this.$axios.get("admin/reports/store-taking", {
                        params: {
                            store_id: this.selectedStore ? this.selectedStore.id : "",
                            from_date: this.appliedFilter.date.startDate,
                            to_date: this.appliedFilter.date.endDate,
                        },
                    });
                    this.reports = response.data.data.logs;
                } catch (e) {
                    this.$root.notify(e);
                } finally {
                    this.disabled = false;
                }
            },
        },
    };
</script>
<style>
    .print-only {
    display: none;
    }
    @media print {
        .not-in-print {
            display: none !important;
        }

        .app-content .side-app {
            padding: 0 !important;
        }

        .print-only {
            display: flex;
            justify-content: center; 
        }

        body * {
            visibility: hidden;
        }
        #print,
        #print * {
            visibility: visible;
            font-size: 1.25rem;
        }
        #print {
            padding: 0 !important;
        }
        #print {
            width: 100%;
        }

        #print .not-in-print {
            display: none;
        }

        .mr-2-print {
            margin-right: 20px;
        }
    }
</style>